import React, { Component } from 'react';
import './Calendar.css';
import Image from 'react-bootstrap/lib/Image';
import custom_icon from '../static/icons/nycustom.svg';

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {entries: null};
    this.update = this.update.bind(this)
  }
  update(){
    const entrs = this.props.calendar.map(obj =>
      <tr className="trdata" key={obj.id}>
        <td className="td">{obj.venue}</td>
        <td className="td">{obj.date}</td>
        <td className="td">{obj.town}</td>
        <td className="td tdicon">
          <a href={obj.ticket_link} target="_blank">
            <Image className="tableicon" alt="Ticket-link" src={custom_icon} />
          </a>
        </td>
      </tr>
    )
    this.setState( { entries:entrs });
  }
  componentDidUpdate(prevProps){
    if (this.props !== prevProps){
      this.update()
    }
  }
  componentDidMount(){
    this.update()
  }
  render() {
    return (
    <div>
      <p className="head">calendar</p>
      <table className="table">
        <thead className="thead">
          <tr className="tr">
            <th className="th">Venue</th>
            <th className="th">Date</th>
            <th className="th">Town</th>
            <th className="th">Ticket-link</th>
          </tr>
        </thead>
        <tbody>
          {this.state.entries}
        </tbody>
      </table>
    </div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/artist/Calendar.js